<style lang="less" scoped>
  .wrap {
    position: relative;
    padding-top: 20px;
  }
</style>
<template>
  <div class="wrap">
    <Spin
      v-if="loading"
      fix
    />
    <h3 class="line text-center">
      借方流水记录
    </h3>
    <Table
      size="small"
      :columns="item_columns"
      :data="selected_statements_borrow"
    />
    <h3 class="line text-center">
      贷方流水记录
    </h3>
    <Table
      size="small"
      :columns="item_columns"
      :data="selected_statements_credit"
    />
    <h3 class="line text-center">
      费用单据
    </h3>
    <Table
      size="small"
      :columns="expense_columns"
      :data="expense_groups"
    />
    <!--  <div
      v-if="bank_statement_items.length"
      class="line text-right"
    >
      <Poptip
        title="你确定要解除关联关系吗？"
        confirm
        @on-ok="releaseRelations"
      >
        <Button type="warning">
          解除关联
        </Button>
      </Poptip>
    </div> -->
    <div style="margin:10px 0">
      <h3 class="line text-center">
        收款单据
      </h3>
      <Table
        size="small"
        :columns="receipt_columns"
        :data="income_bills"
      />
      <div
       
        class="line text-right"
      >
        <Poptip
          title="你确定要解除单据/流水关联关系吗？"
          confirm
          @on-ok="releaseReceiptRelations"
        >
          <Button 
            type="warning"
            :loading="submit_loading"
          >
            解除关联
          </Button>
        </Poptip>
      </div>
    </div>
  </div>
</template>
<script>
  import BankStatementUtil from '../../../fin_statement/libs/util';
  import ViewerItem from '../item';
  import CompanyName from '../../company/name';
  export default {
    comments: {CompanyName},
    props: {
      model_id: {
        type: Number
      },
      close: {
        type: Function,
      }
    },
    data() {
      return {
        submit_loading: false,
        loading: true,
        bank_statement_items: [],
        income_bills:[],
        expense_groups: [],
        item_columns: [
          {
            title: '银行账号',
            key: 'bank_number',
            align: 'center',
            minWidth: 120,
          },
          {
            title: '交易时间',
            key: 'transaction_time',
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatTime(row.transaction_time));
            }
          },
          {
            title: '借方金额',
            align: 'right',
            minWidth: 110,
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.debit_amount));
            }
          },
          {
            title: '贷方金额',
            align: 'right',
            minWidth: 110,
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.credit_amount));
            }
          },
          {
            title: '摘要',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              const row = params.row;
              return h('span', row.remark || '-');
            }
          },
          {
            title: '业务摘要',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              const row = params.row;
              return h('span', row.business_remark || '-');
            }
          },
          {
            title: '流水单号',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              const row = params.row;
              return h('span', row.settle_no || '-');
            }
          },
          {
            title: '其他摘要',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              const row = params.row;
              return h('span', row.other_remark || '-');
            }
          },
          {
            title: '对方户名',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              const row = params.row;
              return h('span', row.opposite_account_name || '-');
            }
          },
          {
            title: '对方账号',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              const row = params.row;
              return h('span', row.opposite_bank_number || '-');
            }
          },
          {
            title: '对方开户行',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              const row = params.row;
              return h('span', row.opposite_bank_name || '-');
            }
          },
        ],
        expense_columns: [
          {
            title: '银行账号',
            key: 'payment_bank_number',
            align: 'center',
            minWidth: 120,
          },
          {
            title: '单据编号',
            key: 'uid',
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              const row = params.row;
              return h(ViewerItem, {
                props: {
                  type: 'ExpenseGroup',
                  model_id: row.id,
                  tip: false
                },
                class: {
                  link: true
                }
              }, row.uid);
            }
          },
          {
            title: '金额',
            align: 'right',
            minWidth: 110,
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.total_price));
            }
          },
          {
            title: '名称',
            key: 'name',
            align: 'center',
            minWidth: 80,
          },
          {
            title: '申请人',
            key: 'apply_user',
            align: 'center',
            minWidth: 80,
          },
          {
            title: '公司',
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              const row = params.row;
              return (
                <CompanyName
                  id={ row.company_id }
                  short
                />
              )
            }
          },
        ]
      }
    },
    computed: {
      selected_statements_borrow() {
        return (this.bank_statement_items || []).filter(item => item.debit_credit_flag === 'debit')
      },
      selected_statements_credit() {
        return (this.bank_statement_items || []).filter(item => item.debit_credit_flag === 'credit')
      },
      receipt_types_hash() {
        return {
          receipt_accrual_bills:'收款计提单',
          receipt_bills:'收款单',
          receivable_bills:'应收单'
        }
      },
      receipt_columns() {
        return [
          {
            title: '单据类型',
            key: 'c_receipt_type',
            align: 'center',
            minWidth: 120,
          },
          {
            title: '单据编号',
            key: 'uid',
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              const row = params.row;
              return h(ViewerItem, {
                props: {
                  type: 'ReceiptDocumentRelations',
                  receipt_type: row.receipt_type,
                  model_id: row.id,
                  tip: false
                },
                class: {
                  link: true
                }
              }, row.uid);
            }
          },
          {
            title: '金额',
            align: 'right',
            minWidth: 110,
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.total_amount));
            }
          },
          {
            title: '名称',
            key: 'name',
            align: 'center',
            minWidth: 80,
          },
          {
            title: '公司',
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              const row = params.row;
              return (
                <CompanyName
                  id={ row.company_id }
                  short
                />
              )
            }
          },
        ]
      }
      //
    },
    created() {
      this.getRelations();
    },
    mounted() {
      //
    },
    methods: {
      getRelations() {
        this.loading = true;
        BankStatementUtil.getItemLinkedRelations(this.model_id).then((data) => {
          const income_bills = []
          Object.keys(data.income_bills).forEach(key => {
            const arr = data.income_bills[key]
            arr.forEach(item => {
              income_bills.push({
                ...item,
                receipt_type: key,
                c_receipt_type: this.receipt_types_hash[key],
              })
            })
          })
          this.income_bills = income_bills
          this.bank_statement_items = data.bank_statement_items;
          this.expense_groups = data.expense_groups;
        }).catch((e) => {
          this.$Modal.error({title: '提示', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
      /* 解除费用单据 */
      /*   releaseRelations() {
        this.loading = true;
        BankStatementUtil.releaseItemLinkedRelations({id:this.model_id, related_type:'expense'}).then((data) => {
          console.log(data);
          window.eventHub.$emit('release-statement-relations');
          this.bank_statement_items = [];
          this.expense_groups = [];
        }).catch((e) => {
          this.$Modal.error({title: '提示', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      }, */
      /* 解除收款单据 */
      releaseReceiptRelations() {
        this.submit_loading = true;
        BankStatementUtil.releaseItemLinkedRelations({id:this.model_id}).then((data) => {
          window.eventHub.$emit('release-statement-relations');
          this.income_bills = []
          this.$Message.success('解除成功！')
          this.close()
        }).catch((e) => {
          this.$vModal.error({title: '提示', content: e.message});
        }).finally(() => {
          this.submit_loading = false;
        });
      }
    }
  }
</script>
